import { extractDateTimeStamp } from '../utils/date-timestamp-extraction';

export interface UnreadHorseNotification {
  horseId: string;
  unreadCount: number;
  latestUnreadAt: Date | null;
  lastUpdatedAt: Date | null;
  createdAt: Date | null;
}

export class UnreadHorseNotificationClass implements UnreadHorseNotification {
  horseId: string;
  unreadCount: number;
  latestUnreadAt: Date | null;
  lastUpdatedAt: Date | null;
  createdAt: Date | null;

  constructor(o: any = {}) {
    this.horseId = o['horseId'] ?? o['id'] ?? '';
    this.unreadCount = o['unreadCount'] ?? 0;
    this.latestUnreadAt = extractDateTimeStamp(
      o['latestUnreadAt'],
      this.horseId
    );
    this.lastUpdatedAt = extractDateTimeStamp(
      o['lastUpdatedAt'],
      this.horseId
    );
    this.createdAt = extractDateTimeStamp(o['createdAt'], this.horseId);
  }
}
